import LetterBoxContainer from "./LetterBox";

const LetterBox = () => {
  return (
    <div className="page-body">
      <LetterBoxContainer />
    </div>
  );
};

export default LetterBox;
